import React, {useEffect} from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { JSONLD, Generic } from 'react-structured-data';

const VHSBlogRollTile = (props: any) => {
	const { blogroll, termMap, coursesOnly, courseIndexLink, placeholderImage, topRef } = props;
	const { t } = useTranslation();
	const terms = [blogroll.post_type, ...blogroll.terms];
	const image = blogroll?.thumbnail && blogroll.thumbnail != '' ? blogroll.thumbnail : ( placeholderImage ? placeholderImage.src : null );

	const provider = {
		"@type": "Organization",
		"name": "Virtual High School",
	};
	const scrollToTop = () => {
		scrollTo({
			top: topRef.current.offsetTop - 32, // go to top of search results -2rem to account for possible overlap with sticky header
		});
	};

	// if there is a news item within terms, do not show the "Post" tag
	const [ postCheck, setPostCheck ] = React.useState(false);

	useEffect( () => {
		if ( blogroll?.post_type=='post' && terms && terms.length > 0 ) {
			terms.map((term_id, index) => {
				const term = termMap ? termMap[term_id] : null;
				if ( term && term.name == 'News') {
					setPostCheck(true);
				}
			});
		}
	}, [] );

	return (
		<div className={`vhs-blogroll__item featured__${blogroll.featured}`}>
			<JSONLD>
				<Generic type='course' jsonldtype="Course" schema={{ name:blogroll.code, description:blogroll.post_title, url:blogroll.permalink, provider: provider }} />
			</JSONLD>
			<div
				className="vhs-blogroll__item-image-wrapper"
				style={{
					backgroundImage: `url(${image})`,
					backgroundSize: 'cover',
					backgroundPosition: 'bottom center',
				}}
			>
				<a
					className="vhs-blogroll__item-link"
					href={blogroll.permalink}
					style={{ height: '100%', width: '100%' }}
					aria-label={`${blogroll.post_title}`}
					// To remove focus from the image link. Typescript expects number for tabindex, but -1 is valid
					// @ts-ignore
					tabIndex='-1'
				></a>
			</div>
			<div className="vhs-blogroll__item-content">
				<a
					className="vhs-blogroll__item-link"
					href={blogroll.permalink}
				>
					{blogroll?.code && (
						<h3 className="vhs-blogroll__item-heading">
							{blogroll.code}
						</h3>
					)}
					{blogroll?.post_title &&
						(blogroll?.post_type == 'course' ? (
							<h6 className="vhs-blogroll__item-subheading">
								{blogroll.post_title}
							</h6>
						) : (
							<h4 className="vhs-blogroll__item-subheading vhs-blogroll__item-subheading--post">
								{blogroll.post_title}
							</h4>
						))}
				</a>
				<ul className="vhs-blogroll__item-tags">
					{! coursesOnly && ! postCheck && (
						<li className={`vhs-blogroll__item-tag vhs-blogroll__item-tag--${blogroll.post_type}`}>
							<a
								href={`${location.pathname}#!post_type=${blogroll.post_type}`}
								onClick={scrollToTop}
							>
								{blogroll.post_type.charAt(0).toUpperCase() +
									blogroll.post_type.slice(1)}
							</a>
						</li>
					)}
					{blogroll?.post_type == 'course' &&
						blogroll?.grade &&
						blogroll?.grade.length > 0 &&
						blogroll?.grade.map((grade, index) => (
							<li className="vhs-blogroll__item-tag" key={index}>
								<a
									href={ `${coursesOnly ? '' : courseIndexLink}${location.pathname}#!grade=${grade.termID}`}
									onClick={scrollToTop}
								>
									{t('GR') + grade.name}
								</a>
							</li>
						))}
					{blogroll?.post_type == 'course' &&
						blogroll?.department_tag && (
							<li className="vhs-blogroll__item-tag">
								<a
									href={`${location.pathname}#!department=${blogroll.department_tag.termID}`}
									onClick={scrollToTop}
								>
									{blogroll.department_tag.name}
								</a>
							</li>
						)}
					{blogroll?.post_type == 'course' &&
						blogroll?.academic_pathway && (
							<li className="vhs-blogroll__item-tag">
								<a
									href={ `${coursesOnly ? '' : courseIndexLink}${location.pathname}#!academic_pathway=${blogroll.academic_pathway.termID}`}
									onClick={scrollToTop}
								>
									{blogroll.academic_pathway.name}
								</a>
							</li>
						)}
					{blogroll?.post_type == 'post' &&
						terms &&
						terms.length > 0 &&
						terms.map((term_id, index) => {
							const term = termMap ? termMap[term_id] : null;
							return term && term?.name != 'Post' ? (
								<li
									className={cn(
										'vhs-blogroll__item-tag',
										`vhs-blogroll__item-tag--${term.name
											.replace(/\s+/g, '-')
											.toLowerCase()}`,
									)}
									key={index}
								>
									<a
										href={`${location.pathname}#!${term.taxonomy}=${term.term_id}`}
										onClick={scrollToTop}
										dangerouslySetInnerHTML={ {__html: term.name} }
									/>
								</li>
							) : null;
						})}
				</ul>
			</div>
		</div>
	);
};

export default VHSBlogRollTile;
